<div scrollY="true">
  <!-- CAN ONLY ACCESS CDR -->
  <div
    style="display: grid; grid-template-columns: 1fr 2fr 1fr 2fr; column-gap: 0.5vw; margin-bottom: 3vh; margin-top: 1vh">
    <div style="text-align: left; align-self: self-end;">
      @if (newDevicesCount.length == 0) {
      <app-skeleton-loader [height]="2"></app-skeleton-loader>
      } @if (newDevicesCount.length > 0) {
      <app-data-tile-list [dataTiles]="newDevicesCount" title="{{deviceStatusCountTotal}}" titleColor="primary">
      </app-data-tile-list>
      }
    </div>
    <div style="text-align: right; align-self: self-end;">
      @if (cdrHealthStatuses.length == 0) {
      <app-skeleton-loader [height]="2"></app-skeleton-loader>
      } @if (cdrHealthStatuses.length > 0) {
      <p style="font-size: 12px; font-weight: 400;">Last updated: {{lastUpdate}}</p>
      <app-data-tile-list statusColor="medium" [dataTiles]="cdrHealthStatuses"> </app-data-tile-list>
      }
    </div>
    <div style="text-align: left; align-self: self-end;">
      @if (groupBundleCount.length == 0) {
      <app-skeleton-loader [height]="2"></app-skeleton-loader>
      } @if (groupBundleCount.length > 0) {
      <app-data-tile-list [dataTiles]="groupBundleCount"> </app-data-tile-list>
      }
    </div>
    <div style="text-align: left; align-self: self-end;">
      @if (deviceBundleUsage.length == 0) {
      <app-skeleton-loader [height]="2"></app-skeleton-loader>
      } @if (deviceBundleUsage.length > 0) {
      <app-data-tile-list [dataTiles]="deviceBundleUsage"> </app-data-tile-list>
      }
    </div>
  </div>

  <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2vw; margin-bottom: 3vh;">
    @if (dataBundleUsageQuadrants.length == 0) {
    <app-skeleton-loader [height]="2"></app-skeleton-loader>
    } @if (dataBundleUsageQuadrants.length > 0) {
    <div>
      <p class="mat-text-primary"
        style="font-size: 20px; font-weight: 500; text-align: left; text-decoration: underline">Data Bundle Usage</p>
      <app-data-value-row-card [dataValues]="dataBundleUsageQuadrants"> </app-data-value-row-card>
    </div>
    }
    @if (activeDeviceHistory.length == 0) {
    <app-skeleton-loader [height]="2"></app-skeleton-loader>
    } @if (activeDeviceHistory.length > 0) {
    <div>
      <p class="mat-text-primary"
        style="font-size: 20px; font-weight: 500; text-align: left; text-decoration: underline">Usage Activity</p>
      <app-data-value-row-card [dataValues]="activeDeviceHistory"> </app-data-value-row-card>
    </div>
    }
  </div>

  <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2vw; margin-bottom: 3%;">
    @if (DailyDataUsageGraphConfig.IsReady) {
    <app-generic-graph-handler #BundleUsageOverTimeGraph [showTools]="false" [graphData]="DailyDataUsageGraphConfig"
      [enableDataLabels]="false" [formatXAxisDate]="false"></app-generic-graph-handler>
    } @else {
    <app-skeleton-loader [height]="12"></app-skeleton-loader>
    }

    @if (usageOverMonthsData != null) {
    <div>
      <app-generic-graph-handler #UsageOverTimeGraph (changed)="getDeviceUsageOvertimeMonths($event)"
        [graphData]="MonthlyDataUsageGraphConfig" [showTools]="false" (selected)="lastSixMonthsPointSelected($event)"
        [formatXAxisDate]="false"></app-generic-graph-handler>

      <button mat-raised-button (click)="lastSixMonthsPointSelected(5)" style="width: 80%;">Reset month to current
        month</button>
    </div>
    }@else {
    <app-skeleton-loader [height]="12"></app-skeleton-loader>
    }
  </div>
  <huge-row>
    <mat-col style="flex-grow: 1">
      @if (!isUsageDataLoaded) {
      <app-skeleton-loader [height]="12"></app-skeleton-loader>
      } @if (deviceUsageData != null) {
      <div [hidden]="deviceUsageData.length == 0">
        <app-data-bar-chart (selected)="barSelected($event)" [month]="currentMonth" [total]="TotalCDRDevices"
          [currentPage]="CurrentPage" [enableDevicesToggle]="true" (deviceSelectionToggled)="selectionChanged($event)"
          [data]="deviceUsageData">
        </app-data-bar-chart>
      </div>
      }
    </mat-col>
  </huge-row>
  <div class="apn-graphs">
    @if (apnsLoading) {
    <app-skeleton-loader [height]="12"> </app-skeleton-loader>
    }
    @if (VodacomConfig.IsReady) {
    <app-generic-graph-handler #vC [graphData]="VodacomConfig" [showTools]="false" [colors]="apnGraphColors"
      [formatXAxisDate]="false"> </app-generic-graph-handler>
    }
    @if (MTNConfig.IsReady) {
    <app-generic-graph-handler #mC [graphData]="MTNConfig" [showTools]="false" [colors]="apnGraphColors"
      [formatXAxisDate]="false"> </app-generic-graph-handler>
    }
    @if (TelkomConfig.IsReady) {
    <app-generic-graph-handler #tC [graphData]="TelkomConfig" [showTools]="false" [colors]="apnGraphColors"
      [formatXAxisDate]="false"> </app-generic-graph-handler>
    }
  </div>
</div>